import { render } from "./ShareholderSurvey.vue?vue&type=template&id=90288d82"
import script from "./ShareholderSurvey.vue?vue&type=script&lang=js"
export * from "./ShareholderSurvey.vue?vue&type=script&lang=js"
script.render = render

export default script